// extracted by mini-css-extract-plugin
export var layoutContainer = "_4n-0";
export var layoutContainerNoRounding = "_4n-6";
export var layoutContainerOpen = "_4n-5";
export var layoutContainerResizing = "_4n-1";
export var mainContent = "_4n-2";
export var resizeDivider = "_4n-3";
export var slidePanel = "_4n-4";